import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TrendUp } from '@phosphor-icons/react';

export const SpendingAnalyticsPanel = ({ analytics }) => {
  const [timeFilter, setTimeFilter] = useState('month');

  const chartData = analytics.map(a => ({
    name: a.project_code_name,
    spending: timeFilter === 'week' ? a.week_spending : timeFilter === 'month' ? a.month_spending : a.year_spending
  }));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-text-primary">Project Spending Analytics</h2>
        <Select value={timeFilter} onValueChange={setTimeFilter}>
          <SelectTrigger className="w-40" data-testid="time-filter-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="week">Last Week</SelectItem>
            <SelectItem value="month">Last Month</SelectItem>
            <SelectItem value="year">Last Year</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="bg-white border border-border-default rounded p-6">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border-default)" />
            <XAxis dataKey="name" stroke="var(--text-secondary)" />
            <YAxis stroke="var(--text-secondary)" />
            <Tooltip
              contentStyle={{ backgroundColor: 'white', border: '1px solid var(--border-default)' }}
              formatter={(value) => [`₹${value.toFixed(2)}`, 'Spending']}
            />
            <Legend />
            <Bar dataKey="spending" fill="var(--accent-brand)" name="Spending (₹)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {analytics.map((a) => (
          <div key={a.project_code_id} className="border border-border-default rounded p-6" data-testid={`analytics-card-${a.project_code_id}`}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accent-brand-subtle flex items-center justify-center">
                <TrendUp size={20} className="text-accent-brand" weight="duotone" />
              </div>
              <h3 className="font-semibold text-text-primary">{a.project_code_name}</h3>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-text-tertiary text-sm">Week</span>
                <span className="font-semibold text-text-primary">₹{a.week_spending.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-tertiary text-sm">Month</span>
                <span className="font-semibold text-text-primary">₹{a.month_spending.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-tertiary text-sm">Year</span>
                <span className="font-semibold text-accent-brand font-bold">₹{a.year_spending.toFixed(2)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpendingAnalyticsPanel;
